var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14 5.775-4-1.333v13.783l4 1.333V5.775Zm2 .102v13.96l3.141-.449a1 1 0 0 0 .859-.99V6.46a1 1 0 0 0-1.141-.99L16 5.877ZM4.859 4.612 8 4.163v13.96l-2.859.408A1 1 0 0 1 4 17.54V5.601a1 1 0 0 1 .859-.99ZM15 22l-6-2-3.576.51A3 3 0 0 1 2 17.542V5.601a3 3 0 0 1 2.576-2.969L9 2l6 2 3.576-.51A3 3 0 0 1 22 6.458v11.94a3 3 0 0 1-2.576 2.969L15 22Z",
    fill: "#777E91"
  })));
};
export default SvgLine;